module.exports = __webpack_public_path__ + "static/media/Hospitalização.090dec88.svg";